/**
 * What a 403 CONSENT_REQUIRED means here (backend: middleware/requireConsent.ts).
 *
 * Kept apart from utils/coreConsents.ts because the HTTP clients import it,
 * and that module imports a client.
 */

import { HttpError } from "@/lib/http";
import type { CoreConsent } from "@/utils/coreConsents";

export const CONSENT_REQUIRED_EVENT = "healthpass:consent-required";

/** The consent a 403 asks for, or null when it is any other failure. */
export function consentRequired(error: unknown): CoreConsent | null {
  if (!(error instanceof HttpError) || error.response?.status !== 403)
    return null;
  const body = error.response.data as
    | { error?: { code?: string; details?: { consentType?: string } } }
    | undefined;
  if (body?.error?.code !== "CONSENT_REQUIRED") return null;
  return body.error.details?.consentType === "AI_PROCESSING"
    ? "AI_PROCESSING"
    : "HEALTH_DATA";
}

/** Announces a missing consent; returns whether the error was one. */
export function handleConsentRequired(error: unknown): boolean {
  const type = consentRequired(error);
  if (!type) return false;
  if (typeof window !== "undefined") {
    window.dispatchEvent(
      new CustomEvent<CoreConsent>(CONSENT_REQUIRED_EVENT, { detail: type }),
    );
  }
  return true;
}
